'use es6';

import styled, { useTheme } from 'styled-components';
import { isHalloween } from '../operators/isHalloween';
import { SpiderWebLeft, SpiderWebRight } from './SpiderWebs';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThemedPage = styled.div.withConfig({
  displayName: "ThemedErrorPage__ThemedPage"
})(["background:", ";background-color:", ";background-size:", ";"], ({
  theme
}) => theme.errorPage.background, ({
  theme
}) => theme.errorPage.backgroundColor, ({
  theme
}) => theme.errorPage.backgroundSize);
export const ThemedErrorPage = ({
  children
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(ThemedPage, {
    children: [isHalloween(theme) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SpiderWebLeft, {}), /*#__PURE__*/_jsx(SpiderWebRight, {})]
    }), children]
  });
};